export const QUILL_AGENT_NAME = 'quill';
